const colors = require("./colors");
const breakpoints = require("./breakpoints");
const { screens, media } = breakpoints;
const font = require("./font");

const KUSTOMER_Z_INDEX = 2147483000;

module.exports = {
  colors,
  font,
  screens,
  media,
  KUSTOMER_Z_INDEX,
};
